import {Form, Modal, ModalBody, ModalHeader} from "reactstrap";
import {I18n} from "../../../I18n/components/promoter";
import React from "react";
import {SUPER_ADMIN} from "../../../helpers/constants";
import CompanySelectRow from "../CompanySelectRow";
import ModalButtonsRow from "../ModalButtonsRow";
import PromoterVideoSelectRow from "./PromoterVideoSelectRow";
import NameInputRow from "../NameInputRow";
import TagsInputRow from "../TagsInputRow";
import DateTimeRow from "../DateTimeRow";
import MinutesBetweenPlaysInputRow from "./MinutesBetweenPlaysInputRow";
import CheckBoxRow from "../CheckBoxRow";
import PromoterSectionMultiSelectRow from "../PromoterSection/PromoterSectionMultiSelectRow";
import PromoterCategoryMultiSelectRow from "../PromoterCategory/PromoterCategoryMultiSelectRow";

const PromoterVideoModal = props => {

    const companiesSelect = props.authority === SUPER_ADMIN
        ? <CompanySelectRow
            lang={props.lang}
            onCompanyChange={props.onInputChange}
            companyId={props.newVideo.companyId}
            companies={props.companies}
            validator={props.validator}
            required
        />
        : null;

    const categorySelect = (
        <PromoterCategoryMultiSelectRow
            lang={props.lang}
            companyIdFilter={props.newVideo.companyId}
            onCategoriesChange={props.onCategoriesChange}
            categoryIds={props.newVideo.categoryIds}
            categories={props.categories}
            validator={props.validator}
        />
    )

    const sectionSelect = (
        <PromoterSectionMultiSelectRow
            lang={props.lang}
            companyIdFilter={props.newVideo.companyId}
            categoryIds={props.newVideo.categoryIds}
            categories={props.categories}
            onSectionsChange={props.onSectionsChange}
            sectionIds={props.newVideo.sectionIds}
            sections={props.sections}
            validator={props.validator}
            required
        />
    )

    const videoSelect = !props.editMode
        ? (
            <PromoterVideoSelectRow
                lang={props.lang}
                fileName={props.newVideo.file ? props.newVideo.file.name : ''}
                onVideoChange={props.onInputChange}
                validator={props.validator}
            />
        ) : (
            <NameInputRow
                lang={props.lang}
                defaultValue={props.newVideo.name}
                onNameChange={props.onInputChange}
                validator={props.validator}
                required
                autoFocus
            />
        )

    const tagsInput = (
        <TagsInputRow
            lang={props.lang}
            onTagsChange={props.onTagsChange}
            tags={props.newVideo.tags}
            validator={props.validator}
        />
    );

    const playOnFaceDetect = (
        <CheckBoxRow
            id="playOnFaceDetect"
            name="playOnFaceDetect"
            label={I18n[props.lang].playOnFaceDetect}
            checked={props.newVideo.playOnFaceDetect}
            onChange={props.onInputChange}
        />
    )

    const turnOnTime = (
        <DateTimeRow
            lang={props.lang}
            label={I18n[props.lang].turnOnTime}
            fieldName="turnOnTime"
            value={props.playbackSettings.turnOnTime}
            onChange={props.onPlaybackSettingsChange}
            validator={props.validator}
            timeFormat="HH:mm"
        />
    );

    const turnOffTime = (
        <DateTimeRow
            lang={props.lang}
            label={I18n[props.lang].turnOffTime}
            fieldName="turnOffTime"
            value={props.playbackSettings.turnOffTime}
            onChange={props.onPlaybackSettingsChange}
            validator={props.validator}
            timeFormat="HH:mm"
        />
    );

    const minutesBetweenPlays = (
        <MinutesBetweenPlaysInputRow
            lang={props.lang}
            value={props.playbackSettings.minutesBetweenPlays}
            onChange={props.onPlaybackSettingsChange}
            validator={props.validator}
        />
    );

    const buttons = (
        <ModalButtonsRow
            lang={props.lang}
            onCancelClick={props.toggle}
            isSaveDisable={props.isSaveDisable}
        />
    )

    return (
        <Modal
            isOpen={props.isModal}
            toggle={props.toggle}
            centered
            autoFocus={!props.editMode}
        >
            <ModalHeader toggle={props.toggle}>
                {I18n[props.lang].modal.addOrEditVideo}
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={props.handleSubmit}>
                    {videoSelect}
                    {companiesSelect}
                    {categorySelect}
                    {sectionSelect}
                    {tagsInput}
                    {playOnFaceDetect}
                    {turnOnTime}
                    {turnOffTime}
                    {minutesBetweenPlays}
                    {buttons}
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default PromoterVideoModal;


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterVideo/PromoterVideoModal.js